/* YTI shared behaviours, safe to load once; guards prevent double-binding */
(function(){
  if (window.__ytiInit) return; window.__ytiInit = true;

  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }

  ready(function(){
    /* faq / curriculum accordions (event-delegated so it covers every section).
       A global flag stops a section-level handler binding a second time and
       toggling the same item straight back closed. */
    if(!window.__tytiFaqBound){
      window.__tytiFaqBound = true;
      document.addEventListener('click',function(e){
        var q=e.target.closest('.faq-q'); if(!q) return;
        e.preventDefault();
        var list=q.closest('.faq-list');
        var item=q.closest('.faq-item') || q.parentElement;
        if(!item) return;
        var open=item.classList.contains('open');
        var scope=list||document;
        scope.querySelectorAll('.faq-item.open').forEach(function(i){
          i.classList.remove('open');
          var b=i.querySelector('.faq-q'); if(b) b.setAttribute('aria-expanded','false');
        });
        if(!open){
          item.classList.add('open');
          q.setAttribute('aria-expanded','true');
          var a=item.querySelector('.faq-a');
          if(a) item.style.setProperty('--faq-h',(a.scrollHeight+40)+'px');
        }
      });
      document.addEventListener('keydown',function(e){
        if(e.key!=='Enter' && e.key!==' ') return;
        var q=e.target.closest && e.target.closest('.faq-q'); if(!q) return;
        e.preventDefault(); q.click();
      });
    }

    /* pricing preview tabs */
    document.querySelectorAll('[data-pp]').forEach(function(scope){
      var tabs=scope.querySelectorAll('.pp-tab'), out=scope.querySelector('[data-pp-best]');
      tabs.forEach(function(tab){
        tab.addEventListener('click',function(){
          tabs.forEach(function(t){t.setAttribute('aria-selected','false');});
          tab.setAttribute('aria-selected','true');
          if(out) out.textContent = tab.getAttribute('data-best') || '';
        });
      });
    });

    /* reveal on scroll */
    var els=document.querySelectorAll('.reveal');
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.08});
      els.forEach(function(el){io.observe(el);});
    } else { els.forEach(function(el){el.classList.add('in');}); }
  });
})();


// /* YTI shared behaviours — safe to load once; guards prevent double-binding */
// (function(){
//   if (window.__ytiInit) return; window.__ytiInit = true;

//   function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }

//   ready(function(){
//     /* faq / curriculum accordions (event-delegated so it covers every section) */
//     document.addEventListener('click',function(e){
//       var q=e.target.closest('.faq-q'); if(!q) return;
//       var list=q.closest('.faq-list'); var item=q.parentElement;
//       var open=item.classList.contains('open');
//       if(list){ list.querySelectorAll('.faq-item.open').forEach(function(i){i.classList.remove('open');}); }
//       if(!open) item.classList.add('open');
//     });

//     /* pricing preview tabs */
//     document.querySelectorAll('[data-pp]').forEach(function(scope){
//       var tabs=scope.querySelectorAll('.pp-tab'), out=scope.querySelector('[data-pp-best]');
//       tabs.forEach(function(tab){
//         tab.addEventListener('click',function(){
//           tabs.forEach(function(t){t.setAttribute('aria-selected','false');});
//           tab.setAttribute('aria-selected','true');
//           if(out) out.textContent = tab.getAttribute('data-best') || '';
//         });
//       });
//     });

//     /* reveal on scroll */
//     var els=document.querySelectorAll('.reveal');
//     if('IntersectionObserver' in window){
//       var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.08});
//       els.forEach(function(el){io.observe(el);});
//     } else { els.forEach(function(el){el.classList.add('in');}); }
//   });
// })();
